export const COMPANY = {
  JNP: "JNP",
  JTP: "JTP",
};
export const COMPANY_PATH = {
  jnp: "jnp",
  jtp: "jtp",
};
